export const EAwardApplyTargetType = {
  All: 0,

  Men: 1,

  Women: 2,

  SelectedCustomers: 3,
} as const

export type EAwardApplyTargetType = (typeof EAwardApplyTargetType)[keyof typeof EAwardApplyTargetType]
